/** Iconografía propia y consistente (trazo de 2 px, 20 × 20). */

const TRAZOS: Record<string, string> = {
  deshacer: 'M8 6 4 10l4 4M4 10h8a4 4 0 0 1 0 8h-2',
  rehacer: 'm12 6 4 4-4 4M16 10H8a4 4 0 0 0 0 8h2',
  exportar: 'M10 3v10m0 0-4-4m4 4 4-4M4 15v2h12v-2',
  importar: 'M10 13V3m0 0L6 7m4-4 4 4M4 15v2h12v-2',
  reproducir: 'M6 4v12l10-6z',
  pausar: 'M6 4h3v12H6zM11 4h3v12h-3z',
  siguiente: 'M5 4v12l8-6zM15 4v12',
  fin: 'M4 4v12l6-6zM10 4v12l6-6zM16 4v12',
  reiniciar: 'M4 10a6 6 0 1 0 2-4.5M4 3v3h3',
  historial: 'M4 10a6 6 0 1 0 1.8-4.3M4 3.5V7h3.5M10 7v3.5l2.5 1.5',
  girar: 'M15 9a5 5 0 1 0-1.5 4.5M15 4v5h-5',
  eliminar: 'M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10',
  cerrar: 'M5 5l10 10M15 5 5 15',
  mas: 'M10 4v12M4 10h12',
  menos: 'M4 10h12',
  iso: 'M10 3 3 7v6l7 4 7-4V7zM3 7l7 4 7-4M10 11v6',
  planta: 'M3 3h14v14H3zM3 10h14M10 3v14',
  centrar: 'M10 3v3M10 14v3M3 10h3M14 10h3M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  alerta: 'M10 3 2 17h16zM10 8v4M10 14.5v.5',
  info: 'M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM10 9v5M10 6.5v.5',
  ok: 'M4 10l4 4 8-8',
  flecha: 'M4 10h12m-4-4 4 4-4 4',
  volver: 'M16 10H4m4-4-4 4 4 4',
  via: 'M4 17 9 3M16 17 11 3M10 6v2M10 11v2M10 15v1',
  elevador: 'M4 17V4M16 17V4M4 6h12M6 11h8',
  cajon: 'M5 17V4h10v13',
  lavado: 'M3 17V5h14v12M7 8v6M13 8v6',
  oficina: 'M3 17V7l7-4 7 4v10zM8 17v-5h4v5',
  ingreso: 'M10 3v14m0 0-4-4m4 4 4-4',
  salida: 'M10 17V3m0 0L6 7m4-4 4 4',
  medidor: 'M4 15a7 7 0 1 1 12 0M10 12l3-4',
  contraerIzq: 'M12 5l-5 5 5 5M16 4v12',
  contraerDer: 'M8 5l5 5-5 5M4 4v12',
  buscar: 'M9 4a5 5 0 1 0 0 10A5 5 0 0 0 9 4zM12.5 12.5 16 16',
  puntoClave: 'M10 17s-5-4.5-5-8.5a5 5 0 0 1 10 0c0 4-5 8.5-5 8.5zM10 7v3',
  llave:
    'M13 3.5a3.5 3.5 0 0 0-3.2 4.9L4 14.2V16h1.8l5.8-5.8A3.5 3.5 0 0 0 16.5 7l-2 2-1.5-1.5 2-2a3.5 3.5 0 0 0-2-2',
  sillon: 'M4 9V6.5A1.5 1.5 0 0 1 5.5 5h9A1.5 1.5 0 0 1 16 6.5V9M3 9h3v3h8V9h3v5H3zM5 14v2M15 14v2',
  arbol: 'M10 17v-5M10 3a4 4 0 0 0-4 4 3.5 3.5 0 0 0 1 6h6a3.5 3.5 0 0 0 1-6 4 4 0 0 0-4-4z',
  columna: 'M5 4h10M5 16h10M7 4v12M13 4v12',
  ajustes: 'M4 6h7M15 6h1M4 14h1M9 14h7M13 4v4M7 12v4',
};

export function Icono({
  nombre,
  tamano = 20,
  titulo,
}: {
  nombre: keyof typeof TRAZOS | string;
  tamano?: number;
  titulo?: string;
}) {
  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={titulo ? undefined : true}
      role={titulo ? 'img' : undefined}
    >
      {titulo ? <title>{titulo}</title> : null}
      <path d={TRAZOS[nombre] ?? TRAZOS.info} />
    </svg>
  );
}

export function Marca({ tamano = 28 }: { tamano?: number }) {
  return (
    <svg width={tamano} height={tamano} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#4C5BD4" />
      <path
        d="M9 10h6a3 3 0 0 1 3 3v6a3 3 0 0 0 3 3h2"
        fill="none"
        stroke="#fff"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <circle cx="9" cy="10" r="2.4" fill="#fff" />
      <circle cx="23" cy="22" r="2.4" fill="#fff" />
    </svg>
  );
}
